import { IconMortgage16, IconSearch16, IconUser16, IconPercent16 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  trackListingClick,
  trackMortgageRateClick,
  trackRealtorClick,
  trackResultShow,
  trackDiscountsClick,
} from './tracking';
import { CalculateResult } from '../../components/CalculateResult';
import { CellLinksLayout, CellLinksItem } from '../../components/CellLinks';
import { selectListingUrl } from '../../selectors/links';
import { EConclusion, ICalculateResult } from '../../types/calculate';

interface ICalculateResultContainerProps {
  calculateResult: ICalculateResult;
}

export const CalculateResultContainer: React.FC<ICalculateResultContainerProps> = ({ calculateResult }) => {
  const listingUrl = useSelector(selectListingUrl);

  React.useEffect(() => {
    trackResultShow(calculateResult.conclusion.type);
  }, [calculateResult]);

  const handleMortgageRateClick = React.useCallback(() => {
    trackMortgageRateClick(calculateResult.conclusion.type);
  }, [calculateResult]);

  const handleListingClick = React.useCallback(() => {
    trackListingClick(calculateResult.conclusion.type);
  }, [calculateResult]);

  const handleRealtorClick = React.useCallback(() => {
    trackRealtorClick(calculateResult.conclusion.type);
  }, [calculateResult]);

  const handleDiscountsClick = React.useCallback(() => {
    trackDiscountsClick(calculateResult.conclusion.type);
  }, [calculateResult]);

  const links = [
    calculateResult.conclusion.type === EConclusion.MortgageProfitable && (
      <CellLinksItem
        icon={<IconMortgage16 color="white_100" />}
        href="/ipoteka-main"
        text="Узнать свои ставки по ипотеке"
        onClick={handleMortgageRateClick}
      />
    ),
    calculateResult.conclusion.type === EConclusion.NotEnoughMoney && (
      <CellLinksItem
        icon={<IconPercent16 color="white_100" />}
        href="/skidki"
        text="Посмотреть скидки на новостройки"
        onClick={handleDiscountsClick}
      />
    ),
    ...(calculateResult.conclusion.type === EConclusion.EnoughMoney
      ? [
          <CellLinksItem
            key="listing"
            icon={<IconSearch16 color="white_100" />}
            href={listingUrl}
            text="Подобрать квартиру"
            onClick={handleListingClick}
          />,

          <CellLinksItem
            key="realtor"
            icon={<IconUser16 color="white_100" />}
            href="/application-form"
            text="Оставить заявку на риелтора"
            onClick={handleRealtorClick}
          />,
        ]
      : []),
  ].filter(Boolean);

  return (
    <CalculateResult
      type={calculateResult.conclusion.type}
      title={calculateResult.conclusion.message}
      blocks={calculateResult.blocks}
      links={Boolean(links.length) && <CellLinksLayout>{links}</CellLinksLayout>}
    />
  );
};
